import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { initPixel, trackPageView } from "@/lib/pixel";

function PixelTracker() {
  const location = useLocation();
  useEffect(() => {
    initPixel();
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

import Home from "@/pages/Home";
import UsedMachines from "@/pages/UsedMachines";
import NewMachines from "@/pages/NewMachines";
import SpareParts from "@/pages/SpareParts";
import CategoriesPage from "@/pages/CategoriesPage";
import SlugRouter from "@/pages/SlugRouter";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SellMachine from "@/pages/SellMachine";
import StaticPage from "@/pages/StaticPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMachines from "@/pages/admin/AdminMachines";
import AdminMachineForm from "@/pages/admin/AdminMachineForm";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminSellers from "@/pages/admin/AdminSellers";
import AdminBuyers from "@/pages/admin/AdminBuyers";
import AdminRequirements from "@/pages/admin/AdminRequirements";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCrmLeads from "@/pages/admin/AdminCrmLeads";
import AdminDeals from "@/pages/admin/AdminDeals";
import AdminServiceCharges from "@/pages/admin/AdminServiceCharges";
import AdminRevenue from "@/pages/admin/AdminRevenue";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSearch from "@/pages/admin/AdminSearch";
import AdminFees from "@/pages/admin/AdminFees";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <PixelTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/used-machines" element={<UsedMachines />} />
              <Route path="/used-machines/:slug" element={<SlugRouter listingType="used" categoryType="machine" basePath="/used-machines" />} />
              <Route path="/new-machines" element={<NewMachines />} />
              <Route path="/new-machines/:slug" element={<SlugRouter listingType="new" categoryType="machine" basePath="/new-machines" />} />
              <Route path="/spare-parts" element={<SpareParts />} />
              <Route path="/spare-parts/:slug" element={<SlugRouter listingType="spare" categoryType="spare" basePath="/spare-parts" />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/sell-your-machine" element={<SellMachine />} />
              <Route path="/privacy-policy" element={<StaticPage type="privacy" />} />
              <Route path="/terms" element={<StaticPage type="terms" />} />

              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="machines" element={<AdminMachines />} />
                <Route path="machines/new" element={<AdminMachineForm />} />
                <Route path="machines/:id" element={<AdminMachineForm />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="sellers" element={<AdminSellers />} />
                <Route path="buyers" element={<AdminBuyers />} />
                <Route path="requirements" element={<AdminRequirements />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="crm-leads" element={<AdminCrmLeads />} />
                <Route path="deals" element={<AdminDeals />} />
                <Route path="service-charges" element={<AdminServiceCharges />} />
                <Route path="revenue" element={<AdminRevenue />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="search" element={<AdminSearch />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="fees" element={<AdminFees />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
